export default "__VITE_ASSET__CCpQN8QG__"